'use client';

import type { SparkEngine } from '@repo/api-gw-sdk';
import { useCallback } from 'react';

import { DeleteEntityDialog } from '@/components/lakehouse/deleteEntityDialog';
import { useDAL } from '@/contexts/useDAL';

interface DeleteSparkEngineDialogProps {
  engine: SparkEngine;
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteSparkEngineDialog = ({
  engine,
  workspaceId,
  open,
  onClose,
  onDeleted,
}: DeleteSparkEngineDialogProps) => {
  const dal = useDAL();

  const handleDelete = useCallback(async () => {
    await dal.lakehouse.deleteSparkEngine(workspaceId, engine.id);
    onDeleted();
  }, [dal, workspaceId, engine.id, onDeleted]);

  return (
    <DeleteEntityDialog
      open={open}
      title='Delete Spark Engine'
      entityLabel='Spark engine'
      entityName={engine.name}
      onClose={onClose}
      onDelete={handleDelete}
      testIdPrefix='confirm-delete-spark-engine'
    />
  );
};
